import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Requires at least `min` entries in an array-valued control (the crime-type pills).
 */
export function minSelectedValidator(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        return Array.isArray(value) && value.length >= min ? null : { minSelected: { min } };
    };
}
